<template>
  <div class="article">
    <div class="article-con">
      <download-btn />
      <div class="article-list">
        <article-item v-for="(item, i) in list" :data="item" :key="item.essayNo"></article-item>
      </div>
      <div class="img-center">
        <!--<img class="img" :src="fileServerDomain+'FotSNkHGnOWddfByxBEyRyuBsj9O'" alt="" @click="goInvitePage">-->
        <!--<img class="img" style="margin: 18px auto 30px;" :src="fileServerDomain+'Fpoc1vMKhU7WTqiuXF_K_X1OhUg9'" alt="" @click="goMall">-->
        <!--<img class="img" :src="fileServerDomain+'Fqkpc9ICWoD4ZCEySZ6ZB9GfJJKl'" alt="" @click="show=true">-->
      </div>

      <!--<div class="annual-goods-con-title">
        <div class="line"></div>
        <div class="goods-con-title">超低价精品</div>
      </div>-->
    </div>

    <!--<div class="button-con" @click="goMall">
      <span class="icon"></span>
      <span class="text">更多京东自营商品1折起 立即选购>></span>
    </div>-->
    <div class="button-con-2" @click="show=true">
      <span>进入云柑社区</span>
    </div>
    <van-popup v-model="show">
      <div class="qrcode-con">
        <img class="img" src="https://fileqn.anttalk.vip/anttalk-miniapp-community.jpg" alt="">
        <div class="title">请长按二维码识别并进入小程序</div>
      </div>
    </van-popup>

    <wx-config v-on:wxConfigReady="wxConfigReady" />
  </div>
</template>

<script>
  import wxConfig from '@/components/weixin/wxConfig'
  import { getEssayByNo } from '@/api/publish'
  import ArticleItem from './components/ArticleItem'
  import DownloadBtn from '@/components/downloadBtn'
  export default {
    components: {
      ArticleItem,
      DownloadBtn,
      wxConfig
    },
    data(){
      return {
        origin: window.location.origin,
        fileServerDomain: this.session('user').fileServerDomain || '',
        list: [],
        show: false,
      }
    },
    watch: {
      $route(){
        if(this.$route.query.essayNo){
          this.getEssayByNo()
        }
      }
    },
    created(){
      if(this.$route.query.essayNo){
        this.getEssayByNo()
      }else {
        this.$toast('文章编号不存在！')
      }

    },
    methods: {
      goMall(){
        let query = {}
        if(this.$route.query.inviteUserId){
          query.inviteUserId = this.$route.query.inviteUserId
        }
        this.$router.push({ name: 'mall', query})
      },

      // goNewActivity(){
      //   this.$router.push({name: 'newActivity'})
      // },
      goSgGoods(query){
        this.$router.push({name: 'jdGoodsDetail', query})
      },

      getEssayByNo(){
        let req = {
          essayNo: this.$route.query.essayNo
        }
        getEssayByNo(req).then(res=>{
          if(res.code===200){
            let data = res.data
            this.list = [data] || []
            if(this.list.length){
              document.title = data.title || data.summary
            }
          }else if(res.code===204){
            window.setTimeout(()=>{
              this.$router.push({name: '404'})
            },500)
          }
        })
      },

      goInvitePage(){
        let url = '';
        if(this.$route.query.inviteUserId){ //如果邀请链接中有 邀请人的openId
          url = '/h5/register?inviteUserId=' + this.$route.query.inviteUserId
        }else {
          url = '/h5/register?inviteUserId=' + this.session('userOpenId') || '0608';
        }
        this.$router.push( url );
      },

      // 微信分享
      wxConfigReady(){
        window.setTimeout(()=>{
          //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
          window.wx.updateAppMessageShareData({
            title: this.list[0].summary, // 分享标题
            desc: '云柑社区-云柑号文章', // 分享描述
            link: this.origin + '/article/articleDetail?essayNo=' + this.list[0].essayNo + '&inviteUserId=' + (this.session('userOpenId')||this.$route.query.inviteUserId),
            imgUrl: this.checkQiNiuUrl(this.list[0].cover) + '?imageView2/0/w/80/h/80', // 分享图标
            success: function () {
              // 设置成功
              console.log('mall 设置分享朋友成功！')
            }
          });
          // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
          window.wx.updateTimelineShareData({
            title: this.list[0].summary, // 分享标题
            link: this.origin + '/article/articleDetail?essayNo=' + this.list[0].essayNo + '&inviteUserId=' + (this.session('userOpenId')||this.$route.query.inviteUserId),
            imgUrl: this.checkQiNiuUrl(this.list[0].cover) + '?imageView2/0/w/80/h/80', // 分享图标
            success: function () {
              // 设置成功
              console.log('mall 设置分享朋友圈成功！')
            }
          })
        },500)
      },

    }
  }
</script>

<style lang="less" scoped>
  @url: '../../assets/article/ad/';
  .article{
    font-size: 15px;
    background-color: #f5f5f5;
    width: 100%;
    height: 100%;
    position: relative;z-index: 0;
    display: flex;
    flex-direction: column;
    /deep/ .download-con{
      position: relative;
    }
    .article-con{
      position: absolute;
      left: 0;right: 0;top: 0px;bottom: 44px;
      overflow-y: auto;z-index: 0;
      .article-list{
        flex: 1;
        padding: 12px 12px 0;
      }
      /*.annual-goods{
        width: 351px;height: 75px;margin: 0 auto 10px;
        background: url("@{url}ad-center.png") no-repeat 50% 50%;
        background-size: 100%;
      }*/
      .img-center{
        padding: 12px;
        .img{
          display: block;width: 100%;margin-bottom: 12px;
          &:last-child{
            margin-bottom: 0;
          }
        }
      }
      /*.annual-goods-con-title{
        display: flex;align-items: center;justify-content: center;
        position: relative;height: 44px;
        .line{width: 351px;height: 1px;background-color: #d1d1d1}
        .goods-con-title{
          font-size: 16px;font-weight: bold;position: absolute;left: 140px;
          color: #f31515;width: 91px;height: 44px;background-color: rgb(244,244,244) ;
          display: flex;justify-content: center;align-items: center;
        }
      }*/
      .annual-goods-con{
        width: 100%;
        margin-bottom: 40px;
        /*
        height: 1100.5px;
        background: url("https://fileqn.anttalk.vip/Fo65x0WXfL6Mf4MB9qzyaf8qwQmR") no-repeat 50% 0;*/
        /*background-size: 351px 1100.5px;
        */
        display: flex;flex-wrap: wrap;
        .item{
          width: 173px;height: 175px;position: relative;z-index: 1;
          display: inline-flex;justify-content: center;align-items: center;
          &:nth-child(2n-1){
            margin: 0 5px 10px 12px;
          }
          .img{
            display: block;width: 100%;
          }
        }
        /*.loop-img(@n, @i: 1) when (@i =< @n) {
          .item@{i}{
            background: url("@{url}@{i}@2x.png") no-repeat 50% 50%;
            background-size: 100%;
          }
          .loop-img(@n, (@i + 1));
        }
        .loop-img(14);*/

      }
    }

    .button-con{
      display: flex;justify-content: center;align-items: center;
      height: 44px;
      position: absolute;bottom: 0;left: 0;right: 0;

      /*background-color: #e0f5ff;
      color: #1585f3;

      background-color: #ffe6e6;
      color: #ef2e2e;

      background-color: #61ac85;
      color: #fff;*/

      background-color: #59adff;
      color: #fff;

      font-size: 16px;
      font-weight: bold;
      .icon{
        display: inline-flex;width: 25px;height: 25px;margin-right: 15px;
        background: url("./jd-icon.png") no-repeat 50% 50%;background-size: 100%;
      }
      .text{
        display: inline-flex;
        height: 40px;overflow: hidden;
        line-height: 40px;
        /*position: absolute;left: 137px;*/
        /*animation: myAnimation 7s infinite linear;*/
      }
    }
    .button-con-2{
      display: flex;justify-content: center;align-items: center;
      height: 40px;
      position: absolute;bottom: 0;left: 0;right: 0;
      background-color: #59adff;
      color: #fff;
      font-size: 15px;
      /*font-weight: bold;*/
    }
    @keyframes myAnimation
    {
      0%   {
        left: -33%;
      }
      10%  {
        left: -22%;
      }
      20%  {
        left: -12%;
      }
      30%  {
        left: 2%;
      }
      40%  {
        left: 16%;
      }
      50%  {
        left: 30%;
      }
      60%  {
        left: 44%;
      }
      70%  {
        left: 58%;
      }
      80%  {
        left: 72%;
      }
      90%  {
        left: 86%;
      }
      100% {
        left: 100%;
      }
    }
    .qrcode-con{
      width: 300px;
      padding: 12px;
      text-align: center;
      .img{
        width: 100%;
      }
      .title{
        padding: 12px 0 0;
      }
    }
  }
</style>
<style lang="less">
  .article{
    .article-list{
      .van-grid-item__content{padding: 0;}
    }
  }
</style>
